var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{ref:"mapRef",style:({
    width: '100% !important',
    height: '100% !important',
  }),attrs:{"center":_vm.center,"options":_vm.options,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,attrs:{"clickable":_vm.markers[index].label === _vm.NavigationState.END,"draggable":false,"position":_vm.markers[index].position,"icon":_vm.markers[index].icon},on:{"click":_vm.redirectGoogleMapsNavigation}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }